<div class="home-container">
    <div class="chart-total">
        <div class="chart-entity-total">
            <ejs-chart id='cEntityTotal' [chartArea]='cEntityTotalArea' [title]='cEntityTotalTitle' [tooltip]='tooltip'
             [primaryXAxis]='cEntityTotalPrimaryXAxis' [primaryYAxis]='cEntityTotalPrimaryYAxis'>
                <e-series-collection>
                    <e-series [dataSource]='cEntityTotalData' [pointColorMapping]='cEntityTotalColorMapping' type='Column' xName='x' yName='y'
                    [cornerRadius]='cEntityTotalCornerRadius'> </e-series>
                </e-series-collection>
            </ejs-chart>
        </div>

        <div class="chart-survey-total">
            <ejs-accumulationchart id="cSurveyTotal" [legendSettings]='cSurveyTotalLegendSettings'
            [title]='cSurveyTotalTitle' [tooltip]='tooltip'
             (tooltipRender)='cSurveyTotalTooltipRender($event)'>
                <e-accumulation-series-collection>
                    <e-accumulation-series [dataSource]='cSurveyTotalData' xName='x' yName='y' [palettes]='cSurveyTotalPalette'
                    [dataLabel]='cSurveyTotalDataLabel' radius="70%"></e-accumulation-series>
                </e-accumulation-series-collection>
            </ejs-accumulationchart>
        </div>
    </div>

    <div class="chart-survey-group">
        <ejs-chart id="cSurveyGroup" [primaryXAxis]='cSurveyGroupPrimaryXAxis'[primaryYAxis]='cSurveyGroupPrimaryYAxis' [title]='cSurveyGroupTitle' [palettes]='palette'
        [tooltip]='tooltip'>
            <e-series-collection>
                <e-series [dataSource]='cSurveyGroupData' type='Column' xName='group' yName='location' name='Location'></e-series>
                <e-series [dataSource]='cSurveyGroupData' type='Column' xName='group' yName='cmr' name='CMR'></e-series>
                <e-series [dataSource]='cSurveyGroupData' type='Column' xName='group' yName='edna' name='eDNA'></e-series>
                <e-series [dataSource]='cSurveyGroupData' type='Column' xName='group' yName='acoustic' name='Acoustic'></e-series>
            </e-series-collection>
        </ejs-chart>
    </div>
</div>
